"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["className", "children", "checked", "disabled"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Radio = /*#__PURE__*/function (_React$PureComponent) {
  function Radio(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Radio);
    _this = _callSuper(this, Radio, [props]);
    _this.state = {
      isChecked: props.checked
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Radio, _React$PureComponent);
  return (0, _createClass2["default"])(Radio, [{
    key: "setRef",
    value: function setRef(el) {
      this.el = el;
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this2 = this;
      event.stopPropagation();
      var target = event.target;
      var isChecked = target.checked,
        value = target.value;
      this.setState({
        isChecked: isChecked
      }, function () {
        var newEvent = new CustomEvent('HTMLEvents', {
          bubbles: true,
          detail: {
            target: target,
            value: value,
            checked: isChecked
          }
        });
        var changeVal = _this2.props.changeVal;
        changeVal(newEvent);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        checked = _this$props.checked,
        disabled = _this$props.disabled,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var isChecked = this.state.isChecked;
      var withChildren = !!children;
      var radio = /*#__PURE__*/_react["default"].createElement(StyledRadio, (0, _extends2["default"])({}, props, {
        checked: Boolean(isChecked),
        className: withChildren ? '' : className,
        described: withChildren,
        onClick: disabled ? null : this.handleChange,
        ref: this.setRef
      }));
      if (!withChildren) {
        return radio;
      }
      return /*#__PURE__*/_react["default"].createElement(StyledLabel, {
        className: className,
        disabled: disabled
      }, radio, children);
    }
  }]);
}(_react["default"].PureComponent);
Radio.propTypes = {
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  children: _propTypes["default"].string,
  className: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};
Radio.defaultProps = {
  checked: false,
  disabled: false,
  children: '',
  className: '',
  onChange: Function.prototype
};
var StyledLabel = _styledComponents["default"].label.withConfig({
  displayName: "Radio__StyledLabel",
  componentId: "sc-lyfr92-0"
})(["cursor:pointer;align-items:center;background-color:transparent;color:#17181a;display:flex;font-size:12px;line-height:16px;", ""], function (props) {
  return props.disabled && "\n    cursor: default;\n  ";
});
var StyledRadio = _styledComponents["default"].input.attrs({
  type: 'radio'
}).withConfig({
  displayName: "Radio__StyledRadio",
  componentId: "sc-lyfr92-1"
})(["", ""], function (props) {
  return props.described && "\n    margin-right: 5px;\n  ";
});
var _default = exports["default"] = Radio;